<template>
  <div class="car-map" :class="{'dark':currentTheme=='darkblue' , 'hide-count':!visibleCount}">
    <sl-amap class="map" :zoom="4" :theme="currentTheme" @ready="handleReady">
      <div class="car-map-search" v-show="!liteMode">
        <div class="car-map-head">
          <div class="car-map-input">
            <div class="car-map-input-wrap">
              <input type="text" placeholder="输入车辆编号/车牌号 回车搜索" v-model="key" @keyup.enter="handleSearch" />
              <Icon class="car-map-close" v-show="visibleDetail" size="20" @click="handleCloseDetail" type="md-close" />
            </div>
            <div class="car-map-menu">
              <!-- <a @click="handleUpdate" v-if="!autoUpdate" > -->
              <a @click="handleUpdate">
                <Icon size="20" :class="{ani:!ready || loading}" type="md-refresh"  />
              </a>
              <a style="margin-left:5px;" :class="{'active':trafficActive}" @click="handleToggleTraffic">
                <Icon custom="i-icon icon-traffic" />
                <span>路况</span>
              </a>
              <a style="margin-left:5px;" :class="{'active':visibleCount}" @click="handleToggleVisibleCount">
                <Icon type="ios-stats" />
                <span>统计</span>
              </a>
            </div>
          </div>
          <div class="car-map-layer flex" v-show="!visibleDetail && visibleCount">
<!--             <div style="padding:8px;">
              <Icon custom="i-icon icon-car" />
              总计 {{this.data.length}} 辆
            </div> -->

            <div v-for="(item) in types" class="car-map-layer-item" @click="toggleData(item.id)" :class="{'car-map-layer-item':1,'disabled':!displayType.visible[item.id]}">
              <div><i :style="{borderColor:item.color}"></i>{{displayType.count[item.id]}}辆</div>
              <div>{{item.label}}</div>
            </div>
          </div>
          <!-- <div class="car-stats">
            <div class="car-stats-item">{{stats.insurance}}<div>保险车辆</div></div>
            <div class="car-stats-item">{{stats.insuranceNot}}<div>无保车辆</div></div>
            <div class="car-stats-item">{{stats.insuranceExpired}}<div>保险到期</div></div>
            <div class="car-stats-item">{{stats.fenceNum}}<div>收派围栏</div></div>
          </div> -->
        </div>
        <div class="car-map-detail" :class="{'active':visibleDetail}">
          <div class="car-map-detail-hd">
            <div class="car-map-detail-status"><span title="电量"><i :class="'icon-battery'+currentData.status.carBatteryValue" class="i-icon"></i>{{currentData.status.carBatteryDisplay}}</span><span title="信号强度"><i :class="'icon-signal-'+currentData.status.gsmWaftValue" class="i-icon"></i>{{currentData.status.gsmWaftDisplay}}</span><span title="卫星数量"><i class="i-icon icon-satellitevariant"></i>{{currentData.status.satelliteWaftDisplay}}</span></div>
            <div class="car-map-detail-hd-title">{{currentData.company.companyName}}</div>
            <p>No. {{currentData.status.carNo}} <span style="margin-left: 5em;"></span></p>
            <p>{{currentData.carStateDisplay}}</p>
            <!-- <button @click="handleOpenTrack"></button> -->
            <button class="car-map-track" @click="handleOpenTrack">
              <div class="ic">
                <Icon type="md-map" size="22" />
              </div>
              <label>轨迹</label>
            </button>
          </div>
          <div class="car-map-detail-bd">
            <p title="车牌号">
              <label>
                <Icon custom="i-icon icon-licenseplate" size="10" /></label>
              <span>{{currentData.license.licenseNo || 'n/a'}}</span>
            </p>
            <p><label>
                <Icon custom="i-icon icon-kuaidiyuan" /></label><span>{{currentData.courierNameDisplay}}</span></p>
            <p><label>
                <Icon type="ios-call" /></label><span>{{currentData.courier ? currentData.courier.phone : 'n/a'}}</span></p>
            <p><label>
                <Icon type="md-speedometer" /></label><span>{{currentData.location ? (currentData.location.speed+' km/h') : 'n/a'}}</span></p>
            <p title="当前位置"><label>
                <Icon type="md-navigate" /></label><span>{{currentData.address || 'n/a'}}</span></p>
            <p title="通信时间"><label>
                <Icon type="md-time" /></label><span>{{currentData.status.heartbeatLastTimeText}}</span></p>
            <p title="定位时间"><label>
                <Icon type="md-time" /></label><span>{{currentData.location.recordDatetimeText}}</span></p>
            <p title="总里程"><label>
                <Icon type="md-flag" /></label><span>{{currentData.totalMileage ? (currentData.totalMileage.toFixed(2)+' km') : 'n/a'}}</span></p>
          </div>
          <!--           <p><label>所属企业</label>{{currentData.company.companyName}}</p>
          <p><label>车辆编号</label>{{currentData.status.carNo}}</p> -->
        </div>
      </div>
      <!-- <div class="car-map-menu">
        <a>
          <Icon custom="i-icon icon-traffic" size="24" />
          <span>路况</span>
        </a>
      </div> -->
    </sl-amap>
    <sl-amap-toolbar :map="map" />

    <!-- <Button  class="list-btn" icon="ios-list-box-outline" type="primary">筛选</Button> -->
  </div>
</template>
<script>
import Poi from '@/components/sl-amap/components/amap-poi'
import { geocoder, latlngFromObject } from '@/components/sl-amap/utils'
import { wgs2gcj } from '@/util/map/proj'
import { getStaticPath } from '@/util/request'
import { tpl, datetime } from '@/util'
import { wgs2gcjForObject, isEqual } from '@/util/map'

import { carStateDisplay, courierNameDisplay, carStatusConv, carLocationConv } from '../partial/utils'
import carTrack from '../track/index'
import carPoiManager from './poi-manager'
import global from '@/util/mixin/global'
import { getPositionByCode } from '@/components/vue-sl/city-select'

const types = [
  // 1 绑定 未行驶
  {id:1,label:'已绑定',color:'rgb(251,142,32)'},
  //未绑定+未欠费
  {id:2,label:'未绑定',color:'#2ab7e9'},
  //绑定行驶中
  {id:3,label:'行驶中',color:'#6bd161'},
  {id:4,label:'欠费锁定',color:'rgb(201,32,65)'},
]

let defaultTheme = location.search.includes('darkblue') ? 'darkblue' : 'whitesmoke'


const promiseZoom = (map, zoom , duration) => {
  return new Promise((resolve) => {
    const onZoomEnd = () => {
      map.remove('zoomend' , onZoomEnd )
      resolve()
    }
    map.on('zoomend' , onZoomEnd )
    map.setZoom(zoom,false,duration)
  })
}

const promiseSetZoomAndCenter = (map, zoom , p, duration) => {
  return new Promise((resolve) => {
    const onEnd = () => {
      map.remove('moveend' , onEnd )
      resolve()
    }
    map.on('moveend' , onEnd )
    map.setZoomAndCenter(zoom,p,false,duration)
  })
}

export default {
  mixins:[global],
  props: {
    autoUpdate:{
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: defaultTheme //whitesmoke
    },
    liteMode: {
      type: Boolean,
      default: false
    },
    visibleEmptyCluster: {
      type: Boolean,
      default: false
    },
    visiblePoint: {
      type: Boolean,
      default: true
    },
    switchZoom: {
      type: Number,
      default: 10
    },
    defaultCarNo:null,
    defaultZoom:null,
    defaultRadius:null,
    defaultAreaCode:null,
    defaultVisibleCount:null
  },
  data() { //
    return {
      types:types,
      currentTheme:'',
      tickTime: 5,
      data: [],
      poiManager: null,
      poiCluster: null,
      map: null,
      key: null,
      ready: false, //<Icon type="md-navigate" />
      focusTpl: `<div class="sl-amap-car-focus"></div>`,
      focusOffset: [-12, -32],
      visible: false,
      currentData: { company: {}, status: {}, location: {}, license: {}, address: '' },
      focusMarker: null,
      focusCarNo: null,
      pollHandler: null,
      focusPollTimer: null,
      params: {
        companyId: null,
      },
      trafficActive: false,
      trafficLayer: null,
      visibleCount:false,
      displayType: {
        visible:{},
        count:{},
      },
      loading:true,
      stats:{},

      animating:false,
      firstRun:true
    }
  },
  computed: {
    visibleDetail() {
      return !!(this.currentData && this.currentData.carNo)
    },
    switchZoomCalc() {
      if (this.params.companyId) {
        return 1
      } else {
        return this.switchZoom
      }
    },
    visibleCluster() {
      return this.isCompany == false
    },
    companyMode() {
      return this.isCompany
    }
  },
  created() {
    if (this.$route.query.companyId) {
      this.params.companyId = this.$route.query.companyId
    }

    if( this.theme ){
      this.currentTheme = this.theme
    }

    for(let i of types){
      this.displayType.visible[i.id] = true
      this.displayType.count[i.id] = 0
    }

    if( this.defaultVisibleCount ){
      this.visibleCount = true
    }
    this.$watch('defaultAreaCode' , function(nv){
      this.changeArea(nv)
    })
    /*this.$request.screenCarStats().then(resp => {
      this.stats = resp.data
    })*/
  },

  beforeDestroy() {
    this.destroy()
  },
  methods: {
    init(map, DistrictCluster, PointSimplifier, utils) {

      let onInit = () => this.afterInit()

      let noop = (e) => {console.log(e,'<><>')}

      let getPointStyle = (id) => {
        return {
          //绘制点占据的矩形区域
          content: PointSimplifier.Render.Canvas.getImageContent(require("./img/"+id+".png"), onInit,noop),
          width: 16,
          height: 20,
          //定位点为中心
          /*
          offset: ['-50%', '-50%'],
          fillStyle: '#ffffff',
          lineWidth: 3,
          strokeStyle: '#6bd161'
          */
        }
      }

      let groupStyleMap = {}

      let massStyles = []

      for(let i of types){
        groupStyleMap[i.id] = { pointStyle: getPointStyle(i.id) }

        massStyles.push({
          url:require("./img/"+i.id+".png"),
          anchor: new AMap.Pixel(8, 20),
          size: new AMap.Size(16, 20),
          zIndex: i.id,
        })
      }
      
      if (this.companyMode) {
        //实时动态
        this.poiManager = new carPoiManager(map, true)
      } else {
        this.poiManager = new PointSimplifier({
          zIndex: 115,
          autoSetFitView: false,
          map: map, //所属的地图实例
          getPosition: (item) => {
            return [item.longitude, item.latitude]
          },
          getHoverTitle: (dataItem, idx) => {
            return '车辆编号: ' + dataItem.carNo;
          },
          //使用GroupStyleRender
          renderConstructor: PointSimplifier.Render.Canvas.GroupStyleRender,
          renderOptions: {
            //点的样式
            pointStyle: {
              width: 16,
              height: 16,
              fillStyle: '#cccccc'
            },
            getGroupId: function(item, idx) {
              //console.log('===>>>>',item.state)
              return item.mixState
            },
            groupStyleOptions: function(gid) {
              return groupStyleMap[gid]
            }
          }
        });

       /* this.poiManager = new AMap.MassMarks([], {
          opacity: 0.8,
          zIndex: 115,
          cursor: 'pointer',
          style: massStyles,
          alwaysRender:false,
        });

        this.poiManager.setMap( map )*/

      }

      this.poiManager.on('pointClick', this.handlePointClick.bind(this))
      /*console.log(this.poiManager.hide.toString())
      this.poiManager.show = function(v){
        if( this.__visible != v ){
          this.__visible = true

          document.querySelector('.base-canvas').style.display = 'block'
        }
      }
      this.poiManager.hide = function(v){
        if( this.__visible != v ){
          this.__visible = false
          console.log('here>>>')
          document.querySelector('.base-canvas').style.display = 'none'
        }
      }*/
      // this.poiManager.on('click', this.handlePointClick.bind(this))


      let visibleEmptyCluster = this.visibleEmptyCluster
      this.poiCluster = new DistrictCluster({
        // zIndex: 100,
        map: map,
        autoSetFitView: false,
        // renderConstructor:CustomRender,
        // renderConstructor: createCustomRender(map , utils , DistrictCluster),

        renderOptions: {
          animEnable: false,
          featureStyleByLevel: {
            country: { fillStyle: 'rgba(0,0,0,0)' },
            province: { fillStyle: 'rgba(0,0,0,0)' },
            city: { fillStyle: 'rgba(0,0,0,0)' },
            district: { fillStyle: 'rgba(0,0,0,0)' }
          },
          featureStyle: {
            lineWidth: 0
          },
          featureEventSupport: false, //区划面是否开启事件支持
          featureClickToShowSub: false, //点击区划面是否触发进入子级区划
          hoverOptions: null,
          getClusterMarker: function(feature, dataItems, recycledMarker) {
            if (visibleEmptyCluster || dataItems.length > 0) {
              return DistrictCluster.ClusterMarkerStrategy.DEFAULT.call(this, feature, dataItems, recycledMarker)
            }
          }

        },
        getPosition: (item) => {
          return [item.longitude, item.latitude]
        },
      });

      let custom = this.custom_fn = '_sl_map_info_window_info_' + Date.now()
      let linkHistory = this.linkHistory_fn = '_sl_map_car_link_to_history_' + Date.now()
      window[custom] = this.close.bind(this)
      window[linkHistory] = this.linkHistory.bind(this)
      this.handlers = { 'close_iw': `window['${custom}']()`, 'link_history': `window['${linkHistory}']()` }

      this.iw = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: '',
        offset: new AMap.Pixel(0, -19)
      });

      this.map.on('zoomend', this.handleMapZoomend.bind(this));
      this.poiCluster.on('clusterMarkerClick', this.handleClusterClick.bind(this))
      //企业模式下定位到对应地区
      if (this.companyMode) {
        const companys = this.userinfo.companys
        if (companys && companys.length) {
          let company = companys[0]
          if (company && company.longitude && company.latitude) {
            map.setZoomAndCenter(13, new AMap.LngLat(company.longitude, company.latitude))
          }
        }
      }

      if( window.location.search ){
        let {lat , lng , theme , zoom = 9 } = this.$route.query
        if( lat && lng ){
          setTimeout(()=>{
            map.setZoomAndCenter(zoom ,  new AMap.LngLat(lng, lat))
          },800)

          this.visibleCount = true
        }

        if( theme ){
          this.currentTheme = theme
        }

      }

    },
    destroy() {
      if (this.custom_fn) {
        delete window[this.custom_fn]
      }
      if (this.pollHandler) {
        window.clearTimeout(this.pollHandler)
      }

      this.iw = null
    },
    afterInit() {

    },
    handleReady(map) {
      this.map = map

      AMapUI.load(['ui/geo/DistrictCluster', 'ui/misc/PointSimplifier', 'lib/$', 'lib/utils'], (DistrictCluster, PointSimplifier, $, utils) => {
        this.init(map, DistrictCluster, PointSimplifier, utils)
        this.fetch()
      });
    },
    async changeArea(areacode){
      // let center = getPositionByCode(this.defaultArea)
      // let nc = new AMap.LngLat(center[0],center[1])
      // this.map.setCenter(nc)
      this.handleCloseDetail()
      let c = this.map.getCenter()
      let dst = getPositionByCode(areacode)
      let nc = new AMap.LngLat(dst[0],dst[1])
      let mc = new AMap.LngLat(c.getLng()  + (dst[0] - c.getLng()) * 0.618,c.getLat()  + ( dst[1] - c.getLat()) * 0.618)
      let targetZoom = this.defaultZoom || this.map.getZoom()
      this.animating = true
      this.poiManager.setData([])
      
      this.fetch()
      
      await promiseSetZoomAndCenter(this.map, 6 , mc,1000)
      await promiseSetZoomAndCenter(this.map, targetZoom , nc,600)
      this.animating = false
      this.poiManager.show()

      await promiseZoom(this.map, targetZoom ,600)


    },
    fetch() {
      this.ready = false
      let params = { ...this.getBounds(), ...this.params }
      
      //defaultRadius
      this.loading = true
      this.$request.screenCarMap(params).then(resp => {
        if(this._isDestroyed) return
        if (resp.code == 0) {

          let data = []
          this.displayType.count = {
            '1':0,
            '2':0,
            '3':0,
            '4':0,
          }

          let currentBound = [];
          let bound = this.map.getBounds();
          for(let i of (resp.data || [])){
            let state = i.mixState
            if (i.lat && i.lng) {
              this.displayType.count[state]++;

              if (
                this.displayType.visible[state]
              ) {
                let c = wgs2gcj(i.lng, i.lat)

                data.push({
                  id: i.id,
                  carNo: i.carNo,
                  longitude: c[0],
                  latitude: c[1],
                  mixState: state,
                  displayLabel: i.license || i.carNo,
                  licenseLite: (i.license || '').replace(/[^a-z0-9]/ig, '').toUpperCase(),
                  tags:[i.carNo , (i.license || '').replace(/[^a-z0-9]/ig, '').toUpperCase() , (i.license || '').replace(/[^0-9]/ig, '').toUpperCase()],

                  lnglat:[...c],
                  style:state
                })

                if (bound.contains(new AMap.LngLat(c[0], c[1]))) {
                  currentBound.push(i.carNo)
                }
              }
            }
          }

          //console.log(currentBound)

          this.data = data

          if (this.visibleCluster) {
            this.poiCluster.setData(this.data);
          }

          if (this.visiblePoint) {
            this.poiManager.setData(this.data)
          }

          this.updateFocus()

          this.loading = false
          if (!this.ready) {
            this.updateViewLayer()
          }
        }
        this.ready = true

        this.pollHandler = null
        if( this.autoUpdate ){
          this.pollHandler = setTimeout(this.fetch.bind(this), this.tickTime * 1000)
        }

        //自动选中
        
        if( this.defaultCarNo){
          let hit = this.data.find(i => i.carNo == this.defaultCarNo)
          // console.log('hit',hit)
          if( hit ) this.focusTo(hit)
        }

        if( this.firstRun ){
          this.firstRun = false
          let targetOptions = [this.map.getZoom(),this.map.getCenter()]
          if( this.defaultZoom ){
            targetOptions[0] = this.defaultZoom
          }
          if( this.defaultAreaCode ){
            let dst = getPositionByCode(this.defaultAreaCode)
            targetOptions[1] = new AMap.LngLat(dst[0],dst[1])
          }

          this.map.setZoomAndCenter(...targetOptions)
        }

      })
    },
    getBounds() {

      let ret = {
        radius:this.defaultRadius || 10000000
      }
      if( this.defaultAreaCode ){
        let hit = getPositionByCode(this.defaultAreaCode)
        ret.lng = hit[0]
        ret.lat = hit[1]
      }else{
        let rate = 1.5
        let def = this.map.getBounds()
        let ne = def.getNorthEast()
        let c = def.getCenter()
        let r = c.distance(ne)

        ret.lng = c.getLng()
        ret.lat = c.getLat()
      }
      

      return ret
    },
    handleMapZoomend() {
      this.updateViewLayer()
    },
    updateViewLayer() {
      // if( this.animating ) return

      let zoom = this.map.getZoom()
      if (zoom > this.switchZoomCalc) {
        if (this.visibleCluster) {
          this.poiCluster.hide()
        }
        if (this.visiblePoint) {
          this.poiManager.show()
        }
      } else {
        if (this.visibleCluster) {
          this.poiCluster.show()
        }
        if (this.visiblePoint) {
          this.poiManager.hide()
        }
      }
    },

    handlePointClick(e, record) {
      if (!this.liteMode) {
        this.focusTo(record.data)
      }
    },
    handleClusterClick(event, record) {
      if (record.feature.properties.level === "district") {
        this.map.setZoomAndCenter(this.switchZoomCalc + 1, new AMap.LngLat(...record.feature.properties.center))
      }
    },
    open(data, position) {
      let d = this.$utils.flat(Object.assign({}, data, this.handlers))
      this.iw.setContent(tpl(this.iwTpl, d))
      this.iw.open(this.map, position)
      this.map.panTo(position)
    },

    focusTo(d) {
      if (d === null) {
        this.focusCarNo = null
        if (this.focusPollTimer) {
          window.clearTimeout(this.focusPollTimer)
        }
        if (this.companyMode) {
          this.poiManager.focus(null)
        } else {
          if (this.focusMarker) {
            this.focusMarker.setMap(null)
            this.focusMarker = null
          }
        }
        return
      }

      if (this.focusCarNo == d.carNo) {
        return
      }

      this.focusCarNo = this.key = d.carNo

      //使用缓存数据定位
      if (d.latitude && d.longitude) {
        let position = new AMap.LngLat(d.longitude, d.latitude)

        let fitZoom = Math.max(this.map.getZoom(), 16)
        this.map.setZoomAndCenter(fitZoom, position)

        if (!this.companyMode) {
          let marker = new AMap.Marker({
            position: position,
            content: this.focusTpl,
            offset: new AMap.Pixel(this.focusOffset[0], this.focusOffset[1])
          })

          if (this.focusMarker) {
            this.focusMarker.setMap(null)
          }

          marker.setMap(this.map)

          this.focusMarker = marker

        } else {
          this.poiManager.focus(d.id)
        }
      }

      this.updateFocusDetail({longitude:d.longitude, latitude:d.latitude})
    },

    updateFocusDetail(extra = {}) {
      this.$request.car(this.focusCarNo).then(resp=>{

        return new Promise((resolve , reject) => {
          //不一致时丢弃
          if( resp.data && resp.data.carNo != this.focusCarNo){
            //break;
            reject()
          }else{
            if( !resp.code ){
              this.$request.carLocation(resp.data.id).then(r => {
                resp.data.location = r.data
                resolve(resp)
              })
            }else{
              resolve(resp)
            }
          }
        })
      }).then(resp => {
        if(resp.data.carNo != this.focusCarNo){
          return 
        }
        
        this.$utils.valid(resp.data, {
          location: {},
          status: {},
          company: {}
        })
        this.$utils.conv(resp.data, {
          carStateDisplay,
          courierNameDisplay
        })

        this.$utils.conv(resp.data.status, carStatusConv)

        if(resp.data.location){
          this.$utils.conv(resp.data.location, carLocationConv)
          wgs2gcjForObject(resp.data.location);
        }

        //默认从详情接口获取位置数据
        // 如果传递缓存新位置，则从缓存中取
        if (extra) {
          for (let i in extra) {
            resp.data.location[i] = extra[i]
          }
        }
        if(resp.data.location){
          let requireUpdateAddress = !isEqual(resp.data.location, this.currentData.location)

          if (requireUpdateAddress) {
            let position = latlngFromObject(resp.data.location)

            geocoder(position).then(r => {
              resp.data.address = r
              this.currentData = resp.data
            }, () => {
              this.currentData = resp.data
            })
          } else {
            resp.data.address = this.currentData.address
            this.currentData = resp.data
          }
        }

        // this.currentData = resp.data

        //this.map.panTo(position)

        // this.open(resp.data, position)
      },() => {})
    },

    close() {
      this.map.clearInfoWindow()
    },
    handleSearch() {
      if (this.key) {
        let key = this.key.toUpperCase()
        let hit = this.data.find(i => i.tags.includes(key))
        if (hit) {
          this.focusTo(hit)
        } else {
          this.$Message.error('没有搜索到车辆');
        }
      }
    },
    handleUpdate() {
      this.fetch()
    },
    handleOpenTrack() {
      this.$dialog({
        width: 80,
        transitionNames: ['none', 'none'],
        paddingless: true,
        render: (h) => {
          return h(carTrack, { props: { id: this.currentData.id ,extra:{ licenseNo: this.currentData.license.licenseNo || 'n/a', carNo:this.currentData.carNo} } })
        }
      })
    },
    handleCloseDetail() {
      this.currentData = { company: {}, status: {}, location: {}, license: {}, address: '' }
      this.focusCarNo = this.key = null

      this.focusTo(null)
    },

    handleToggleTraffic() {
      if (!this.trafficLayer) {
        this.trafficLayer = new AMap.TileLayer.Traffic();
      }

      this.trafficActive = !this.trafficActive
      if (this.trafficActive) {
        this.map.add(this.trafficLayer)
      } else {
        this.map.remove(this.trafficLayer)
      }
    },

    //更新当前选中的车辆
    updateFocus() {
      if (this.focusMarker && this.focusCarNo) {
        let d = this.data.find(i => i.carNo == this.focusCarNo)
        if (d) {
          let p = new AMap.LngLat(d.longitude, d.latitude)

          this.focusMarker.setPosition(p)
          this.map.panTo(p)

          this.updateFocusDetail({
            longitude: d.longitude,
            latitude: d.latitude,
          })
        }
      }
    },
    linkHistory() {

    },
    handleToggleVisibleCount(){
      this.visibleCount = !this.visibleCount
    },
    toggleData(key) {
      this.displayType.visible[key] = !this.displayType.visible[key]
      console.log(this.displayType)
      if (this.pollHandler) {
        window.clearTimeout(this.pollHandler)
      }
      this.fetch()

    }
  }
}

</script>
<style lang="scss">
.car-map {
  position: relative;
  width: 100%;
  height: 100%;

  .map {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .car-map-search {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 360px;
  }

  .car-map-head {
    position: relative;
    top: auto;
    right: auto;

    border-radius: 2px 2px 0 0;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0px rgba(0, 0, 0, 0.02);

    .car-map-input-wrap {
      flex: auto;
      display: flex;
      align-items: center;
    }

    input {
      padding: 10px;
      background: rgba(0, 0, 0, .5);
      color: #eee;
      outline: none;
      border: rgba(0, 167, 210, .5) solid 2px;
      box-shadow: 0 0 30px 10px rgba(0, 167, 210, .2) inset;
      width: 100%;
      flex: auto;
    }

    .car-map-input {
      padding: 12px;
      display: flex;
    }


    .car-map-layer {
      display: flex;
      justify-content: space-around;
      color: rgba(0, 0, 0, 0.75);
      .car-map-layer-item{
        text-align: center;
        padding: 10px 0;
        color:rgba(0,0,0,.7);
        flex:1;
        cursor: pointer;
        i{ 
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 6px;
          background: #fff;
          border: solid 4px #2ab7e9;
          margin-right: 5px;
        }
        &.disabled{
          opacity: 0.5;
        }
        &.disabled i{
          border-color: gray;
        }
      }
    }

    input {
      border: none;
      background: none;
      box-shadow: none;
      margin-bottom: 0;
      padding: 0;
      color: #666;

      // box-shadow: 0 0 30px 10px rgba(0, 0, 0, .2) inset;
      &::-webkit-input-placeholder {
        color: #999;
      }

    }

    .car-map-close {
      color: #666;
    }
  }

  .car-map-menu {

    /*
    position:absolute;
    left:400px;
    top:10px;
    border-radius: 2px 2px 0 0;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0px rgba(0, 0, 0, 0.02);
    padding:10px 12px;
    */
    display: flex;
    @keyframes ani-spin-circle {
      from { transform: rotate(0deg);}
      50%  { transform: rotate(180deg);}
      to   { transform: rotate(360deg);}
    }

    .ani{
      animation: ani-spin-circle 1s linear infinite;
    }
    a {
      color: #5f6477;
      display: flex;
      align-items: center;

      &:hover {
        opacity: 0.8;
      }

      &.active {
        color: #4285F4;
      }
    }

  }

  .car-map-detail {
    transition: all 0.3s;
    width: 350px;
    position: relative;
    color: #666;
    display: none;
    border-top: 1px solid rgb(230, 230, 230);
    width: 100%;
    margin-top: 10px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0px rgba(0, 0, 0, 0.02);
    line-height: 2em;

    .car-map-track {
      position: absolute;
      right: 15px;
      bottom: 15px;


      outline: none;
      border: none;

      .ic {
        width: 42px;
        height: 42px;
        background: #fff;
        border-radius: 42px;
        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);

        display: flex;
        align-items: center;
        justify-content: center;
      }

      i {
        // color: rgba(0, 167, 210, .5); //#4285F4
        color: #4285F4;
      }

      label {
        display: block;
        overflow: visible;
        font-weight: 500;
        cursor: inherit;
      }
    }

    button {
      float: right;
      background: transparent;
      border: rgba(255, 255, 255, .85) solid 1px;
      padding: 0 5px;
      color: #eee;
      border-radius: 5px;
    }

    &.active {
      display: block;
    }

    .car-map-detail-status {
      display: flex;
      margin-bottom: 5px;
      justify-content: space-between;
      align-items: center;

      i {
        // font-size: 22px;
        margin-right: 5px;
      }
    }

    .car-map-detail-hd {
      padding: 16px 24px 16px;
      position: relative;
      background: #4285F4;
      color: #fff;

      .car-map-detail-hd-title {
        font-size: 16px;
        margin: 0.6em 0;
        font-weight: 500;
      }
    }

    .car-map-detail-bd {
      padding: 16px;
      p {
        display: flex;
        align-items: center;
        padding: 4px 24px 4px 0;
      }


      p label {
        flex: 0 0 24px;
        margin: 0 12px;
        font-size: 18px;
        line-height: 0;

      }
    }
  }
}



.car-map.dark {
  .car-map-search {
    position: absolute;
    right: 10px;
    top: 40px;
    left:auto;
    z-index: 2;
    .car-map-head{
      background: rgba(0, 167, 210, 0.35);
    }
    .car-map-input{
      // padding:0;
    }
    .car-map-menu{
      *{ color:#ddd; }
    }
    input{
      color: #eee;
      background:none;
    }
    .car-map-close{
      color:#ddd;
    }
  }
  .car-map-layer {
    background: rgba(0, 167, 210, .35);
    display: flex;
    justify-content: space-around;

    div {
      color: #ddd;
    }
  }

  .car-map-detail{
    width: 100%;
    background: rgba(0,167,210,.35);
    border: 1px solid rgba(0,167,210,.1);
    color: #eee;
    line-height: 2em;

    .car-map-detail-hd{
      background:none;
      color:#eee;
    }
  }
}

.car-map.hide-count{
  .amap-ui-district-cluster-marker-body{
    display: none !important;
  }
}
.car-stats {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items:center;
  text-align: center;
  border-top:1px solid rgba(0,0,0,.1);
  .car-stats-item{
    line-height: 1em;
    padding:8px 0;
    div {
      color: #333;
      line-height: 1em;
      padding-bottom:0.5em;
    }
  }
}
</style>